<template>
  <div v-if="brand" class="brand-card">
    <div class="brand-card__img">
      <img
        :src="brand.head_img | image($store.state._env.MEDIA_ENDPOINT)"
        :alt="brand.head_img | image_alt"
        :title="brand.title"
        loading="lazy"
      />
    </div>
    <div class="brand-card__description">
      {{ brand.description }}
    </div>
  </div>
</template>

<script>
export default {
  name: "BrandCardComponent",
  props: {
    brand: Object,
  },
};
</script>

<style lang="stylus">
.brand-card {
  border: 1px solid var(--gray)
  border-radius: var(--main_radius)
  padding 30px
  display flex
  align-items flex-start
  gap 30px
  margin-bottom 30px
  +below(768px) {
    flex-direction column
    align-items center
  }
  +below(540px) {
    padding 20px
  }

  &__img {
    width 200px
    flex-shrink 0
    border: 1px solid var(--gray)
    border-radius: var(--big_radius)
    padding 30px
    +below(540px) {
      padding 20px
    }
  }
}
</style>
